var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading)?_c('span',[_c('a',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadBimesterDisenrollsCsv(_vm.doyang.id)}}},[_vm._v("Bajas: ")]),_c('span',[_vm._v(_vm._s(_vm.doyang.risk_students_count || 0))])]):_c('span',[_vm._v(" Cargando bajas... ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }